import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquare, faCheckSquare } from '@fortawesome/free-regular-svg-icons'
import { InputCheckbox, CheckboxLabel } from 'components/generic/Input/CheckboxInput/styles'

const CheckboxInput = React.forwardRef(({ label, isValid = true, ...rest }, ref) => {
  return (
    <CheckboxLabel>
      <InputCheckbox type='checkbox' ref={ref} isValid={isValid} {...rest} />
      <FontAwesomeIcon icon={faSquare} />
      <FontAwesomeIcon icon={faCheckSquare} />
      <span>{label}</span>
    </CheckboxLabel>
  )
})

// Need this to get around false positive lint issue
// see https://github.com/yannickcr/eslint-plugin-react/issues/2269
CheckboxInput.displayName = 'CheckboxInput'

export default CheckboxInput
